import {IAction} from "../../../interfaces/IAction";
import {RequestActionTypes} from "./create_request_action_types";

export enum RequestState {
    None,
    Waiting,
    Success,
    Error
}

export const reduceRequestState =
    (requestTypes: RequestActionTypes) =>
    (state: RequestState = RequestState.None, action: IAction): RequestState => {
        switch (action.type) {
            case requestTypes.start:
                return RequestState.Waiting;
            case requestTypes.success:
                return RequestState.Success;
            case requestTypes.error:
                return RequestState.Error;
            case requestTypes.reset:
                return RequestState.None;
            default:
                return state;
        }
    };
